const colors = ['#4080FF', '#FC9EC6', '#F979B7', '#21D2D1', '#C296ED', '#A871E3', '#7BE189']

function parseFraction(str: string): number {
  if (!str || typeof str !== 'string') return 0
  const parts = str.split('/')
  if (parts.length !== 2) return NaN // 非分数格式返回NaN

  const numerator = Number(parts[0])
  const denominator = Number(parts[1])

  // 防止除以0的情况
  if (denominator === 0) return 0

  return Math.round((numerator * 100) / denominator) || 0
}

export default (data: any, totalNum: number) => {
  const { citationSummary, enhancedReport } = data.result
  const brandVisibility = [] // 品牌知名度
  const brandImageTags = [] // 词云数据来源
  let geoDiagnosis = '' // geo专业建议
  let coverageArr = [] // 提及率
  let completionArr = [] // 完成度
  let mentioningRateArr = [] // 首选被提及率
  let dataOverview = [] // 数据概览
  let keywordRate = [] // AI回复内容类型占比
  const modelCitationDetail = [] // 模型引用详情
  const brandAwareness = [] // 品牌认知
  let informationCompletenessSource = [] // 信息完整性来源

  const { totalCitationCount } = citationSummary || {}
  let marginVal = totalCitationCount || 0
  const arr = [
    {
      key: 'newsMedia',
      name: '新闻/财经 ',
      value: 0,
      color: colors[0],
    },
    {
      key: 'official',
      name: '品牌官网/政府门户',
      value: 0,
      color: colors[1],
    },
    {
      key: 'search',
      name: '搜索引擎聚合',
      value: 0,
      color: colors[2],
    },
    {
      key: 'socialUGC',
      name: '自媒体平台',
      value: 0,
      color: colors[3],
    },
    {
      key: 'industryVertical',
      name: '垂直行业媒体',
      value: 0,
      color: colors[4],
    },
  ]
  if (citationSummary?.citationPlatformDistribution) {
    arr.forEach(x => {
      if (citationSummary.citationPlatformDistribution[x.key]) {
        // eslint-disable-next-line no-param-reassign
        x.value = citationSummary.citationPlatformDistribution[x.key]
        marginVal -= x.value
      }
    })
    if (marginVal) {
      arr.push({ key: 'other', name: '其他', value: marginVal, color: colors[5] })
    }
    arr.forEach(x => {
      if (x.value) {
        modelCitationDetail.push({
          ...x,
          value: Math.round((x.value * 100) / totalCitationCount) || 0,
        })
      }
    })
  }

  const effectiveCitationCount = Math.round(
    (citationSummary.effectiveCitationCount * 100) / totalCitationCount || 0,
  )
  const nowCompanyInfo = enhancedReport.find(x => x.isPrimarySubject)

  const sentimentPolarityMap = {
    Positive: '积极',
    Negative: '消极',
    Neutral: '中立',
  }
  const sentimentVal = nowCompanyInfo?.consultationSubjectAnalysis?.sentimentPolarity || 'Neutral'
  dataOverview = [
    { num: totalCitationCount, title: '总引用' },
    { num: effectiveCitationCount, title: '有效引用' },
    {
      num: sentimentPolarityMap[sentimentVal],
      title: '提及情绪偏好',
    },
  ]
  if (nowCompanyInfo) {
    geoDiagnosis = nowCompanyInfo.geoStrategyReport
    nowCompanyInfo.consultationSubjectAnalysis?.brandImageTags?.forEach(x => {
      brandImageTags.push({
        name: x.keyword,
        value: x.value,
      })
    })
    nowCompanyInfo.consultationSubjectAnalysis?.coreServicePerception?.forEach(x => {
      try {
        const match = x.match(/^(.*?)[(（](\d+)[)）]$/)
        const [name, value] = match ? [match[1], match[2]] : [x, 0]
        brandAwareness.push({ name, value: Number(value) })
      } catch {
        brandAwareness.push({ name: x, value: 0 })
      }
    })
    const completenessLabels = [
      '基本资料',
      '企业优势',
      '产品服务',
      '核心产品',
      '信任背书',
      '合作案例',
      '产品详情',
      '应用场景',
      '推广区域',
    ]
    informationCompletenessSource = completenessLabels.map(label => ({
      label,
      value: nowCompanyInfo.informationCompletenessSource?.includes(label) ? 100 : 0,
    }))
  }
  const mentionedTypeMap = {
    ordinary_information: { name: '普通回复', value: 0, color: colors[0] },
    commercial_consultation: { name: '商业类型回复', value: 0, color: colors[1] },
    cooperation_case: { name: '案例回复', value: 0, color: colors[2] },
    ctaType: { name: 'CTA类型回复', value: 0, color: colors[3] },
    other: { name: '其他类型回复', value: 0, color: colors[4] },
  }

  let coverageValArr = [] // 覆盖率数组
  let mentionStrengthArr = [] // 提及强度数组
  let completionArray = [] // 信息完整度数组
  let mentioningRateArray = [] // 首选被提及率数组
  let qdMentionArray = [] // 强烈推荐数组
  let referenceLinkCountArr = [] // 引用链接数组

  let maxMentionCountVal = 0
  let maxQdMentionCountVal = 0
  let maxQdMentionVal = 0
  let maxTopMentionCount = 0

  enhancedReport.forEach(item => {
    const completionVal = parseFraction(item.informationCompletenessDetail)
    const coverageVal = Math.floor(((item.tqMentionedByModels || 0) * 100) / totalNum)
    const mentioningRateVal = Math.floor(((item.topMentionCount || 0) * 100) / totalNum)
    coverageValArr.push(coverageVal)
    mentionStrengthArr.push(Math.floor(((item.qdMention || 0) * 100) / totalNum))
    completionArray.push(completionVal)
    mentioningRateArray.push(mentioningRateVal)
    qdMentionArray.push(item.qdMention && item.topMentionCount ? 100 : 30)
    referenceLinkCountArr.push(item.mentionedByModels?.length || 0)

    maxMentionCountVal = Math.max(maxMentionCountVal, item.mentionCount || 0)
    maxQdMentionCountVal = Math.max(maxQdMentionCountVal, item.qdMentionCount || 0)
    maxQdMentionVal = Math.max(maxQdMentionVal, item.qdMention || 0)
    maxTopMentionCount = Math.max(maxTopMentionCount, item.topMentionCount || 0)

    coverageArr.push({
      label: item.brandName,
      value: coverageVal,
      isPrimarySubject: item.isPrimarySubject,
    })
    if (item.mentionCount) {
      mentioningRateArr.push({
        label: item.brandName,
        value: item.mentionCount,
        isPrimarySubject: item.isPrimarySubject,
      })
    }
    // 统计mentionedByModels中的contextType
    item.mentionedByModels?.forEach(x => {
      if (mentionedTypeMap[x.contextType]) {
        mentionedTypeMap[x.contextType].value += 1
      } else {
        mentionedTypeMap[x.contextType] = { name: x.contextType, value: 1, color: '#FF4703' }
      }
    })
  })
  enhancedReport.forEach(item => {
    let mentionScore = 0
    let qdMentionScore = 0
    let qdMentionCountScore = 0
    let topMentionScore = 0

    if (item.mentionCount) {
      mentionScore = maxMentionCountVal > 0 ? item.mentionCount / maxMentionCountVal : 0
    }
    if (item.qdMention) {
      qdMentionScore = maxQdMentionVal > 0 ? item.qdMention / maxQdMentionVal : 0
    }
    if (item.qdMentionCount) {
      qdMentionCountScore =
        maxQdMentionCountVal > 0 ? item.qdMentionCount / maxQdMentionCountVal : 0
    }
    if (item.topMentionCount) {
      topMentionScore = maxTopMentionCount > 0 ? item.topMentionCount / maxTopMentionCount : 0
    }
    const score01 =
      0.3 * mentionScore +
      0.25 * qdMentionScore +
      0.25 * topMentionScore +
      0.2 * qdMentionCountScore
    const score100 = Math.round(score01 * 10000) / 100
    if (score100) {
      completionArr.push({
        label: item.brandName,
        value: score100.toFixed(2),
        isPrimarySubject: item.isPrimarySubject,
      })
    }
  })

  keywordRate = Object.values(mentionedTypeMap).filter(x => x.value)
  if (nowCompanyInfo) {
    // 目标公司
    brandVisibility.push([
      {
        name: '覆盖率',
        value: Math.floor(((nowCompanyInfo.tqMentionedByModels || 0) * 100) / totalNum),
      },
      {
        name: '首选提及',
        value: Math.floor(((nowCompanyInfo.topMentionCount || 0) * 100) / totalNum),
      },
      {
        name: '首选推荐',
        value: nowCompanyInfo.qdMention && nowCompanyInfo.topMentionCount ? 100 : 30,
      },
      {
        name: '信息完整度',
        value: parseFraction(nowCompanyInfo.informationCompletenessDetail),
      },
      {
        name: '提及强度',
        value: Math.floor(((nowCompanyInfo.qdMention || 0) * 100) / totalNum),
      },
      {
        name: '引用链接数',
        value: nowCompanyInfo.mentionedByModels?.length || 0,
      },
    ])
  } else {
    brandVisibility.push([
      { name: '覆盖率', value: 0 },
      { name: '首选提及', value: 0 },
      { name: '首选推荐', value: 0 },
      { name: '信息完整度', value: 0 },
      { name: '提及强度', value: 0 },
      { name: '引用链接数', value: 0 },
    ])
  }
  coverageValArr = coverageValArr.sort((a, b) => b - a)
  mentionStrengthArr = mentionStrengthArr.sort((a, b) => b - a)
  completionArray = completionArray.sort((a, b) => b - a)
  mentioningRateArray = mentioningRateArray.sort((a, b) => b - a)
  qdMentionArray = qdMentionArray.sort((a, b) => b - a)
  referenceLinkCountArr = referenceLinkCountArr.sort((a, b) => b - a)
  const coverageValTotal = coverageValArr.slice(0, 3).reduce((a, b) => a + b, 0)
  const mentionStrengthTotal = mentionStrengthArr.slice(0, 3).reduce((a, b) => a + b, 0)
  const completionTotal = completionArray.slice(0, 3).reduce((a, b) => a + b, 0)
  const mentioningRateTotal = mentioningRateArray.slice(0, 3).reduce((a, b) => a + b, 0)
  const qdMentionTotal = qdMentionArray.slice(0, 3).reduce((a, b) => a + b, 0)
  const referenceLinkCountTotal = referenceLinkCountArr.slice(0, 3).reduce((a, b) => a + b, 0)

  // 行业最大值
  brandVisibility.push([
    { name: '覆盖率', value: coverageValArr[0] || 0 },
    { name: '首选提及', value: mentioningRateArray[0] || 0 },
    { name: '首选推荐', value: qdMentionArray[0] || 0 },
    { name: '信息完整度', value: completionArray[0] || 0 },
    { name: '提及强度', value: mentionStrengthArr[0] || 0 },
    { name: '引用链接数', value: referenceLinkCountArr[0] || 0 },
  ])
  // 行业均值
  brandVisibility.push([
    { name: '覆盖率', value: Math.round(coverageValTotal / 3) },
    { name: '首选提及', value: Math.round(mentioningRateTotal / 3) },
    { name: '首选推荐', value: Math.round(qdMentionTotal / 3) },
    { name: '信息完整度', value: Math.round(completionTotal / 3) },
    { name: '提及强度', value: Math.round(mentionStrengthTotal / 3) },
    { name: '引用链接数', value: Math.round(referenceLinkCountTotal / 3) },
  ])

  coverageArr = coverageArr.sort((a, b) => b.value - a.value)
  completionArr = completionArr.sort((a, b) => b.value - a.value)
  mentioningRateArr = mentioningRateArr.sort((a, b) => b.value - a.value)

  return {
    brandVisibility,
    brandImageTags,
    geoDiagnosis,
    brandAwareness,
    coverageArr,
    dataOverview,
    keywordRate,
    modelCitationDetail,
    completionArr,
    mentioningRateArr,
    informationCompletenessSource,
  }
}
